import { doc, getDoc } from 'firebase/firestore';
import { db } from '@/integrations/firebase/client';

export interface InsightDoc {
  comment: string;
  end: string;
  personaId: string;
  personaImg: string;
  personaName: string;
  start: string;
  type: 'like' | 'dislike' | 'worst' | 'best';
}

export interface RecommendationDoc {
  priority: 'high' | 'medium' | 'low';
  comment: string;
  personas: {
    id: string;
    name: string;
    image: string;
  }[];
}

export interface SenseAnalysisDoc {
  block: number;
  start: number;
  end: number;
  score: number;
  summary: string;
  insights?: any[];
}

export interface RatingDoc {
  type: string;
  min: number;
  max: number;
  avg: number;
  comment: string;
}

export interface FeedbackSummaryDoc {
  id: string;
  insights?: InsightDoc[];
  recommendations?: RecommendationDoc[];
  sense_analysis?: SenseAnalysisDoc[];
  ratings?: RatingDoc[];
}

export async function getFeedbackSummary(feedbackId: string): Promise<FeedbackSummaryDoc | null> {
  if (!feedbackId) return null;
  
  try {
    const docRef = doc(db, 'feedbacks', feedbackId, 'results', 'summary');
    const snap = await getDoc(docRef);
    
    if (!snap.exists()) return null;
    
    return { id: snap.id, ...snap.data() } as FeedbackSummaryDoc;
  } catch (error) {
    console.error('Error getting feedback summary:', error);
    return null;
  }
}